export default "__VITE_ASSET__BjpoEA8U__"